<script lang="ts">
  import { useNavigate } from "svelte-navigator";
  import type { BlogItem } from "../../../app/store/store-blog";
  import ReadMoreButton from "./ReadMoreButton.svelte";
  import { getTimeDistance } from "../utils";

  export let blog: BlogItem;

  const time = getTimeDistance(blog.time);
  const navigate = useNavigate();
</script>

<div class="relative">
  <div class="shadow-background" />
  <div
    class="relative bg-white p-3 cursor-pointer tracking-[0.02em]"
    on:keypress
    on:click={() => {
      navigate(`/blog/${blog.id}`);
    }}
  >
    <div class="rounded-lg">
      <img src={blog.image} class="rounded-lg" alt={blog.title} />
    </div>

    <div class="px-4 py-5">
      <div class="mb-1 text-primary-indigo-blue uppercase font-semibold">
        {time}
      </div>

      <div class="mb-3 text-dark-300 font-semibold text-[18px]">
        {blog.title}
      </div>

      <div class="mb-4 typo-paragraph-2 text-dark-50">{blog.description}</div>

      <div class="tracking-normal">
        <ReadMoreButton>Read More</ReadMoreButton>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  .shadow-background {
    @apply absolute top-6 -bottom-3 left-4 right-4;
    background: #3754aa;
    opacity: 0.16;
    filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
  }
</style>
